import { cn } from "admin-ui/utils/cn"

import { IconProps } from "."

export default function TriangleDownMini({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M12.5 7.77832C12.4994 7.794 12.496 7.81161 12.4893 7.83008L12.458 7.8877L9.86816 11.3418C9.83931 11.3803 9.79311 11.4205 9.72754 11.4512C9.66171 11.4818 9.58272 11.5 9.5 11.5C9.45886 11.5 9.41882 11.4955 9.38086 11.4873L9.27344 11.4512C9.24061 11.4359 9.21285 11.418 9.18945 11.3994L9.13281 11.3418L6.54199 7.8877C6.51198 7.84759 6.50118 7.80945 6.5 7.77832L6.50586 7.72852L6.53223 7.67188C6.54518 7.65193 6.56312 7.63136 6.58594 7.61133L6.6709 7.55469C6.73888 7.52055 6.82199 7.50002 6.91016 7.5H12.0898L12.2168 7.51465L12.3291 7.55469C12.363 7.57174 12.3911 7.59118 12.4141 7.61133L12.4678 7.67285C12.4803 7.69229 12.4892 7.71077 12.4941 7.72852L12.5 7.77832Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
